import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { FormService } from '../../services/form.service';

@Component( {
	selector: 'app-health-insurance',
	templateUrl: './health-insurance.component.html',
	styleUrls: ['./health-insurance.component.scss']
} )
export class HealthInsuranceComponent implements OnInit {
	public formGroupName: string = 'health_insurance';
	public healthInsuranceForm!: UntypedFormGroup;

	constructor(public formService: FormService) {}

	ngOnInit(): void {
		this.healthInsuranceForm = this.formService.thirdPartyForm.get(this.formGroupName) as UntypedFormGroup;

		// Get country from main form and verify it
		const countryFrom = this.formService.verifyCountryCode(this.formService.mainForm.get('movingFrom')?.get('country')?.value);

		// Set default nationality if not already set
		if( !this.healthInsuranceForm.get('countryOfOrigin')?.value && countryFrom ) {
			this.healthInsuranceForm.get('countryOfOrigin')?.setValue(countryFrom);
			this.healthInsuranceForm.get('countryOfOrigin')?.markAsDirty();
		}
	}

	onSubmit(): void {
		this.formService.submitThirdPartyFormGroup(this.healthInsuranceForm);
	}

	incrementDependants(): void {
		let current = this.healthInsuranceForm.get('dependants')?.value || 0;
		this.healthInsuranceForm.get('dependants')?.setValue(current + 1);
	}

	decrementDependants(): void {
		let current = this.healthInsuranceForm.get('dependants')?.value || 0;
		if (current > 0) {
			this.healthInsuranceForm.get('dependants')?.setValue(current - 1);
		}
	}
}
